// Copyright (c) 2025 Digital Asset (Switzerland) GmbH and/or its affiliates. All rights reserved.
// SPDX-License-Identifier: Apache-2.0
import { Theme } from '@mui/material';

export const dataGridSx = (theme: Theme) => ({
  border: 0,

  '.MuiDataGrid-columnHeaders': {
    border: 0,
  },
  '.MuiDataGrid-virtualScroller': {
    boxShadow: `inset 0 0 0 1px ${theme.palette.divider}`,
    borderRadius: 1,
    minHeight: '52px',
  },
  '.MuiDataGrid-columnHeaderTitle': {
    color: 'secondary.main',
    fontWeight: 'bold',
    textTransform: 'uppercase',
    fontSize: theme.typography.caption.fontSize,
  },
  '.MuiDataGrid-footerContainer': {
    borderTop: 0,
  },

  '.MuiDataGrid-cell:focus': {
    outline: 'none',
  },
  '.MuiDataGrid-cell:focus-within': {
    outline: 'none',
  },
});
